<div class="header-holder">
  <spb-logo></spb-logo>

  <div class="borgo">
    <a href="https://www.borgohypotek.se/" target="_blank">
      <img alt="Borgo" src="./assets/borgo.svg">
    </a>
  </div>

  <div class="spb-filler"></div>

  @if (applicationService.currentUser$().personNummer) {
    <div class="user">
      {{ applicationService.currentUser$().name }}
    </div>

  }
  <spb-toggle-button></spb-toggle-button>
  <button [matMenuTriggerFor]="menu" mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>

  <mat-menu #menu>
    <button [routerLink]="['/', 'start' ]" mat-menu-item>Byt</button>
    @if (developerMode) {
      <button [routerLink]="['/', 'impersonate' ]" mat-menu-item>Användare
      </button>
    }

    <button (click)="userService.logout()" mat-menu-item>Logga ut</button>
  </mat-menu>

</div>
